import * as React from 'react';

import { PrintPreviewDTO, PrintTemplateType } from 'core/api';

import RdlTemplatePrintPreview from './RdlTemplatePrintPreview';
import EscPosTemplatePrintPreview from './EscPosTemplatePrintPreview';

interface Props extends React.HTMLProps<any> {
	preview: PrintPreviewDTO;
}

export default function TemplatePrintPreview(props: Props) {
	return props.preview.TemplateType === PrintTemplateType.EscPos
		? <EscPosTemplatePrintPreview preview={props.preview} />
		: <RdlTemplatePrintPreview preview={props.preview} />;
}
